export class AppointmentTypeResponseModel{
    crmAppointmentTypeId:number;
    crmAppointmentTitle:string;

}